import React, { useEffect, useState } from "react";
import { Row, Col } from "antd";
// Styles
import { Wrapper, H3 } from "./styles";

import Table from "../../components/table";
import Search from "../../components/table/search";

// Hooks
import useHistorical from '../../hooks/useHistorical';

import RenderOf from './of';
import RenderPiece from './pieces';

//import multilanguage library
import { useTranslation } from 'react-i18next'

const RenderHistorical = ({ changeTitle }) => {
  const [listOf, setListOf] = useState([]);
  const [selectedOf, setSelectedOf] = useState(null);
  const [selectedRowKey, setSelectedRowKey] = useState([]);

  const { historical, setPiece, pieceSelected } = useHistorical();

  //To translate text
  const { t } = useTranslation();

  useEffect(() => {
    changeTitle && changeTitle("historical");
  }, [changeTitle]);

  useEffect(() => {
    const normalized = historical.map(his => {
      return {
        key: his.idOF,
        ...his
      };
    });

    normalized && setListOf(normalized);
    if (normalized && normalized[0]) {
      setSelectedOf(normalized[0]);
      setSelectedRowKey([normalized[0].key]);
    }
  }, [historical]);

  //When change OF set the first piece has selected piece
  useEffect(() => {
    if(selectedOf) {
      if (selectedOf.pieces && selectedOf.pieces.length > 0) {
        setPiece(selectedOf.pieces[0])
      }
    }
  }, [selectedOf])


  const columns = [
    {
      title: t('table.header.of'),
      dataIndex: "idOF",
      key: "idOF",
      sorter: (a, b) => a.idOF - b.idOF,
      defaultSortOrder: "descend",
      ...Search("idOF")
    },
    {
      title: t('table.header.article'),
      dataIndex: "article.articleName",
      key: "articleName",
      sorter: (a, b) => a.article.articleName.localeCompare(b.article.articleName),
      defaultSortOrder: "descend"
    },
    {
      title: t('table.header.design'),
      dataIndex: "design.desingName",
      key: "design.desingName",
      sorter: (a, b) => a.design.desingName.localeCompare(b.design.desingName),
      defaultSortOrder: "descend"
    }
  ];

  // rowSelection objects indicates the need for row selection
  const rowSelection = {
    selectedRowKeys: selectedRowKey,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKey(selectedRowKeys);
    },
    onSelect: (record, selected, selectedRows) => {
      setSelectedOf(historical.find(obj => obj.idOF === record.idOF));
    },
    //no existe en type: radio
    onSelectAll: (selected, selectedRows, changeRows) => {
      console.log(selected, selectedRows, changeRows);
    },
    type: "radio"
  };

  const clickRow = row => {
    setSelectedRowKey([row.key]);
    setSelectedOf(historical.find(obj => obj.idOF === row.idOF));
  };

  return (
    <Wrapper>
        <Row style={{ margin: 0 }} gutter={[16, 16]}>
            <Col xl={6} lg={24} md={24}>
              <H3>{t('headers.historical.of_list')}</H3>
              <Table data={listOf} columns={columns} rowSelection={rowSelection} onClick={() => clickRow} />
            </Col>
            <Col xl={9} lg={24} md={24}>
              <H3>{t('headers.historical.of', {value: selectedOf && selectedOf.idOF})}</H3>
              <RenderOf OF={selectedOf} />
            </Col>
            <Col xl={9} lg={24} md={24}>
              <H3>{t('headers.historical.piece_number', {value: pieceSelected && pieceSelected.number})}</H3>
              <RenderPiece design={selectedOf && selectedOf.design} />
            </Col>
        </Row>
    </Wrapper>
  );
};
export default RenderHistorical;
